module.exports = __webpack_public_path__ + "media/images/gallery/stars/orion/rigel_vis-41ce5894b822d75de3a19406f469d724.jpg";